import { SiteUrls } from '@tableau/shared-urls';
import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { classes } from 'typestyle/lib';

import { Formatters, Messages } from '../../codegen/Localize';
import { CountPill } from '../../commonInfra/components/dataGrid/CellWithCount';
import { CellWithPopover } from '../../commonInfra/components/dataGrid/CellWithPopover';
import { cssClass, flexColumnStyle, textEllipsis } from '../../style';
import { FlowBaseInfo } from '../models/FlowInfo';

const cssPrefix = 'FlowLinksWithIcon';

const flowIconClass = 'tb-link-flow';

export const displayedLinkClass = cssClass(cssPrefix, 'displayedLink', textEllipsis, {
  display: 'inline-block',
  verticalAlign: 'top',
  maxWidth: 150,
});

const textClass = cssClass(cssPrefix, 'text', {
  display: 'inline-flex',
});

const flowLinksClass = cssClass(cssPrefix, 'flowLinks', flexColumnStyle);

const tooltipRootClass = cssClass(cssPrefix, 'tooltipRoot', {
  padding: TabStyles.Spacing.DefaultSpace
});

const tooltipItemClass = cssClass(cssPrefix, 'tooltipItem', textEllipsis, {
  paddingTop: TabStyles.Spacing.DefaultSpace,
  paddingBottom: TabStyles.Spacing.DefaultSpace
});

export type FlowLinksWithIconProps = {
  readonly flows: ReadonlyArray<FlowBaseInfo>;
  readonly hideIcon?: boolean;
  readonly siteUrls: SiteUrls;
};

export class FlowLinksWithIcon extends React.PureComponent<FlowLinksWithIconProps> {

  private getContent = () => {
    return (
      <div className={tooltipRootClass}>
        <div className={flowLinksClass}>
          {this.props.flows.map((flow, index) => {
            return <div key={index} className={tooltipItemClass}>{this.renderFlowLink(flow, false)}</div>;
          })}
        </div>
      </div>
    );
  };

  private renderFlowLink(flow: FlowBaseInfo, isDisplayedLink: boolean) {
    const url = this.props.siteUrls.flowUrl(flow.id);
    return isDisplayedLink ?
      <a className={displayedLinkClass} title={flow.name} href={url}>{flow.name}</a> :
      <a title={flow.name} href={url}>{flow.name}</a>;
  }

  private getCountPill = () => {
    return <CountPill count={'+' + (this.props.flows.length - 1)} />;
  };

  private renderFlowLinks() {
    return (this.props.flows.length > 1 ?
      <>
        {this.renderFlowLink(this.props.flows[0], true)}
        <CellWithPopover
        cellContent={this.getCountPill()}
        popoverContent={this.getContent()}
        title={Messages.flowsPublishingCount({FLOW_COUNT_LOC: Formatters.formatCount(this.props.flows.length)})}
        showTitleBar={true}
        />
      </> :
      <>
        {this.renderFlowLink(this.props.flows[0], true)}
      </>
    );
  }

  public render() {
    if (!this.props.flows || this.props.flows.length === 0) {
      return null;
    }

    const rootClass = this.props.hideIcon ? textClass : classes(textClass, flowIconClass);
    return (
      <span className={rootClass}>
        {this.renderFlowLinks()}
      </span>
    );
  }
}
